import React from 'react';
import RecentActivityScreenshots from './RecentActivityScreenshots';
import { Box } from '@mui/material';
const screenshots = [
  {
    timeRange: '10:00 am - 10:10 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '/assets/images/carousel/carousel-01.png',
    progress: { total: 40, cursor: 20, keyboard: 40 },
  },
  {
    timeRange: '10:15 am - 10:25 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '/assets/images/carousel/carousel-02.png',
    progress: { total: 60, cursor: 10, keyboard: 30 },
  },
  {
    timeRange: '10:30 am - 10:40 am',
    user: 'Amit Goyal',
    task: 'UI Design',
    image: '',
    progress: { total: 70, cursor: 5, keyboard: 25 },
  },
  {
    timeRange: '10:45 am - 10:55 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '/assets/images/carousel/carousel-04.png',
    progress: { total: 30, cursor: 40, keyboard: 30 },
  },
  {
    timeRange: '11:00 am - 11:10 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '/assets/images/carousel/carousel-01.png',
    progress: { total: 80, cursor: 10, keyboard: 10 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 50, cursor: 20, keyboard: 30 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 0, cursor: 0, keyboard: 0 },
  },
  {
    timeRange: '11:15 am - 11:25 am',
    user: 'Amit Goyal',
    task: 'Code Review',
    image: '',
    progress: { total: 0, cursor: 0, keyboard: 0 },
  },
];

// Helper function to chunk arrays
const chunkArray = (array, size) =>
  Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
    array.slice(i * size, i * size + size)
  );

const UserActivity = ({ showSummary, showIndexCircle, showProgress, limit }) => {
  const chunksOf6 = chunkArray(screenshots, 6);
  const visibleScreenshots = limit ? screenshots.slice(0, limit) : screenshots;


  return (
    <>
      <Box>
        {chunksOf6.slice(0, 1).map((chunk, index) => (
          <RecentActivityScreenshots
            key={`six-${index}`}
            data={visibleScreenshots}
            columns={limit ? 6 : 6}
            showProgress={showProgress}
            showIndexCircle={showIndexCircle}
            showSummary={showSummary}
          />
        ))}
      </Box>
    </>
  );
};

export default UserActivity;
